var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "relative p-7 grid grid-rows-6 gap-y-4"
  }, [_c('div', {
    staticClass: "row-span-1 grid grid-cols-12 gap-x-6",
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "col-span-4 flex justify-center",
    attrs: {
      "id": "photo"
    }
  }, [((_vm.personnal || {}).profile_image || {}).isDisplayed ? _c('profile-picture', {
    attrs: {
      "id": "photo",
      "size": "max-w-36 w-36 h-36",
      "supports-object-fit": false,
      "is-circle-avatar": false,
      "specific-url": ((_vm.personnal || {}).profile_image || {}).value || null,
      "with-border": false
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    class: 'col-span-8 flex flex-col space-y-2 items-center justify-center px-5 ' + _vm.colorBgLight,
    attrs: {
      "id": "header-plus"
    }
  }, [_vm.personnal.prenom.isDisplayed || _vm.personnal.nom.isDisplayed ? _c('div', {
    staticClass: "text-left text-xl"
  }, [_vm.personnal.prenom.isDisplayed ? _c('span', [_vm._v("\n          " + _vm._s(_vm.personnal.prenom.value) + "\n        ")]) : _vm._e(), _vm._v(" "), _vm.personnal.nom.isDisplayed ? _c('span', [_vm._v("\n          " + _vm._s(_vm.personnal.nom.value) + "\n        ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    class: 'text-base-2 ' + _vm.colorText
  }, [_vm._v("\n        " + _vm._s(_vm.name) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "text-2sm text-center"
  }, [_vm._v("\n        " + _vm._s(_vm.description) + "\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row-span-5 grid grid-cols-12 gap-x-6"
  }, [_c('div', {
    class: 'relative col-span-4 ' + _vm.colorBgLight + ' pl-7 pr-9 py-6 flex flex-col space-y-4 h-full',
    attrs: {
      "id": "side"
    }
  }, [_vm.personnal.adresse.value && _vm.personnal.adresse.isDisplayed && _vm.personnal.adresse.value != '' || _vm.personnal.date_naissance.value && _vm.personnal.date_naissance.isDisplayed && _vm.personnal.date_naissance.value != '' || _vm.personnal.email.value && _vm.personnal.email.isDisplayed && _vm.personnal.email.value != '' || _vm.personnal.telephone.value && _vm.personnal.telephone.isDisplayed && _vm.personnal.telephone.value != '' || _vm.personnal.site_web.value && _vm.personnal.site_web.isDisplayed && _vm.personnal.site_web.value != '' || _vm.personnal.linkedin.value && _vm.personnal.linkedin.isDisplayed && _vm.personnal.linkedin.value != '' ? _c('div', {
    staticClass: "flex flex-col space-y-1.5",
    attrs: {
      "id": "contact"
    }
  }, [_c('div', {
    class: 'uppercase text-base-2 font-semibold ' + _vm.colorText + ' text-left'
  }, [_vm._v("\n          Contact\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "border-t border-gray-900 w-10"
  }), _vm._v(" "), _vm.personnal.date_naissance.value && _vm.personnal.date_naissance.isDisplayed && _vm.personnal.date_naissance.value != '' ? _c('div', {
    attrs: {
      "id": "date_naissance"
    }
  }, [_c('p', {
    staticClass: "text-2sm font-semibold text-gray-900"
  }, [_vm._v("\n            Date de naissance\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "text-2sm text-gray-600"
  }, [_vm._v("\n            " + _vm._s(new Date(_vm.personnal.date_naissance.value).toLocaleDateString()) + "\n          ")])]) : _vm._e(), _vm._v(" "), _vm.personnal.adresse.value && _vm.personnal.adresse.isDisplayed && _vm.personnal.adresse.value != '' ? _c('div', {
    attrs: {
      "id": "adresse"
    }
  }, [_c('p', {
    staticClass: "text-2sm font-semibold text-gray-900"
  }, [_vm._v("\n            Adresse\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "text-2sm text-gray-600"
  }, [_vm._v("\n            " + _vm._s(_vm.personnal.adresse.value) + "\n          ")])]) : _vm._e(), _vm._v(" "), _vm.personnal.email.value && _vm.personnal.email.isDisplayed && _vm.personnal.email.value != '' ? _c('div', {
    attrs: {
      "id": "email"
    }
  }, [_c('p', {
    staticClass: "text-2sm font-semibold text-gray-900"
  }, [_vm._v("\n            Email\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "text-2sm text-gray-600"
  }, [_vm._v("\n            " + _vm._s(_vm.personnal.email.value) + "\n          ")])]) : _vm._e(), _vm._v(" "), _vm.personnal.telephone.value && _vm.personnal.telephone.isDisplayed && _vm.personnal.telephone.value != '' ? _c('div', {
    attrs: {
      "id": "telephone"
    }
  }, [_c('p', {
    staticClass: "text-2sm font-semibold text-gray-900"
  }, [_vm._v("\n            Téléphone\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "text-2sm text-gray-600"
  }, [_vm._v("\n            " + _vm._s(_vm.personnal.telephone.value) + "\n          ")])]) : _vm._e(), _vm._v(" "), _vm.personnal.site_web.value && _vm.personnal.site_web.isDisplayed && _vm.personnal.site_web.value != '' ? _c('div', {
    attrs: {
      "id": "siteweb"
    }
  }, [_c('p', {
    staticClass: "text-2sm font-semibold text-gray-900"
  }, [_vm._v("\n            Site internet\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "text-2sm text-gray-600",
    attrs: {
      "href": 'https://' + _vm.personnal.site_web.value
    }
  }, [_vm._v("\n            " + _vm._s(_vm.personnal.site_web.value) + "\n          ")])]) : _vm._e(), _vm._v(" "), _vm.personnal.linkedin.value && _vm.personnal.linkedin.isDisplayed && _vm.personnal.linkedin.value != '' ? _c('div', {
    attrs: {
      "id": "linkedin"
    }
  }, [_c('p', {
    staticClass: "text-2sm font-semibold text-gray-900"
  }, [_vm._v("\n            Linkedin\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "text-2sm text-indigo-600 italic underline",
    attrs: {
      "href": 'https://' + _vm.personnal.linkedin.value
    }
  }, [_vm._v("\n            " + _vm._s(_vm.personnal.linkedin.value) + "\n          ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm.personnal.permis_conduire.isDisplayed && _vm.personnal.permis_conduire.value.filter(function (p) {
    return p != 'Autres';
  }).length > 0 || _vm.personnal.moyen_transport.isDisplayed && _vm.personnal.moyen_transport.value.filter(function (m) {
    return !['Autres', 'Aucun'].includes(m);
  }).length > 0 ? _c('div', {
    staticClass: "flex flex-col space-y-1.5",
    attrs: {
      "id": "permis"
    }
  }, [_c('div', {
    class: 'uppercase text-base-2 font-semibold ' + _vm.colorText + ' text-left'
  }, [_vm._v("\n          Permis\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "border-t border-gray-900 w-10"
  }), _vm._v(" "), _vm.personnal.permis_conduire.isDisplayed && _vm.personnal.permis_conduire.value.filter(function (p) {
    return p != 'Autres';
  }).length > 0 ? _c('div', {
    staticClass: "flex flex-col space-y-1.5"
  }, [_c('p', {
    staticClass: "text-2sm font-semibold text-gray-900"
  }, _vm._l(_vm.personnal.permis_conduire.value.filter(function (p) {
    return p != 'Autres';
  }), function (permis, kp) {
    return _c('span', {
      key: kp
    }, [_vm._v("\n              " + _vm._s(permis)), kp < _vm.personnal.permis_conduire.value.filter(function (p) {
      return p != 'Autres';
    }).length - 1 ? _c('span', [_vm._v(",\n              ")]) : _vm._e()]);
  }), 0)]) : _vm._e(), _vm._v(" "), _vm.personnal.moyen_transport.isDisplayed && _vm.personnal.moyen_transport.value.filter(function (m) {
    return !['Autres', 'Aucun'].includes(m);
  }).length > 0 ? _c('div', {
    staticClass: "flex flex-col space-y-1.5",
    attrs: {
      "id": "moyens_transport"
    }
  }, [_c('p', {
    staticClass: "text-2sm font-semibold text-gray-900"
  }, [_vm._v("\n            Moyen de déplacement\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "text-2sm text-gray-600"
  }, _vm._l(_vm.personnal.moyen_transport.value.filter(function (m) {
    return !['Autres', 'Aucun'].includes(m);
  }), function (transport, kt) {
    return _c('span', {
      key: kt
    }, [_vm._v("\n              " + _vm._s(transport)), kt < _vm.personnal.moyen_transport.value.filter(function (m) {
      return !['Autres', 'Aucun'].includes(m);
    }).length - 1 ? _c('span', [_vm._v(",\n              ")]) : _vm._e()]);
  }), 0)]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm.personnal.travailleur_handicape.value ? _c('div', {
    staticClass: "flex flex-col space-y-1.5",
    attrs: {
      "id": "infos"
    }
  }, [_c('div', {
    class: 'uppercase text-base-2 font-semibold ' + _vm.colorText + ' text-left'
  }, [_vm._v("\n          Informations personnelles\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "border-t border-gray-900 w-10"
  }), _vm._v(" "), _c('p', {
    staticClass: "text-2sm font-semibold text-gray-900"
  }, [_vm._v("\n          Reconnaissance en tant que travailleur handicapé\n        ")])]) : _vm._e(), _vm._v(" "), _vm.langues.filter(function (l) {
    return l.isDisplayed;
  }).length > 0 ? _c('div', {
    staticClass: "flex flex-col space-y-1.5",
    attrs: {
      "id": "langues"
    }
  }, [_c('div', {
    class: 'uppercase text-base-2 font-semibold ' + _vm.colorText + ' text-left'
  }, [_vm._v("\n          Langues\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "border-t border-gray-900 w-10"
  }), _vm._v(" "), _vm._l(_vm.langues.filter(function (l) {
    return l.isDisplayed;
  }), function (langue, kl) {
    return _c('p', {
      key: kl,
      staticClass: "text-2sm"
    }, [_c('span', {
      staticClass: "font-semibold text-gray-900"
    }, [_vm._v("\n            " + _vm._s(langue.value.name) + " :\n          ")]), _vm._v(" "), _c('span', {
      staticClass: "text-gray-600"
    }, [_vm._v("\n            " + _vm._s(_vm.niveaux[langue.value.niveau]) + "\n          ")])]);
  })], 2) : _vm._e(), _vm._v(" "), _vm.hobbies.filter(function (h) {
    return h.isDisplayed;
  }).length > 0 ? _c('div', {
    staticClass: "flex flex-col space-y-1.5",
    attrs: {
      "id": "interets"
    }
  }, [_c('div', {
    class: 'uppercase text-base-2 font-semibold ' + _vm.colorText + ' text-left'
  }, [_vm._v("\n          Centres d'intérêt\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "border-t border-gray-900 w-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex-wrap"
  }, _vm._l(_vm.hobbies.filter(function (h) {
    return h.isDisplayed;
  }), function (hobbie, kh) {
    return _c('p', {
      key: kh,
      staticClass: "text-2sm font-semibold text-gray-900"
    }, [_c('span', {
      staticClass: "mx-1"
    }, [_vm._v(_vm._s(kh > 0 ? '-' : ''))]), _vm._v(_vm._s(hobbie.value) + "\n          ")]);
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-span-8 flex flex-col space-y-6",
    attrs: {
      "id": "content"
    }
  }, [_vm.pros.filter(function (p) {
    return p.isDisplayed;
  }).length > 0 ? _c('div', {
    staticClass: "flex flex-col space-y-1.5",
    attrs: {
      "id": "xp"
    }
  }, [_c('div', {
    class: 'text-base-2 ' + _vm.colorText + ' font-semibold uppercase'
  }, [_vm._v("\n          Expériences\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "border-t border-gray-900 w-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-4 flex flex-col space-y-3.5"
  }, _vm._l(_vm.pros.filter(function (p) {
    return p.isDisplayed;
  }), function (pro, pi) {
    return _c('div', {
      key: pi,
      staticClass: "grid grid-cols-12 gap-x-2.5"
    }, [_c('div', {
      staticClass: "col-span-3 uppercase text-2sm font-semibold"
    }, [_vm._v("\n              " + _vm._s(_vm.formatDatesWithSeparator(pro, true)) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "col-span-9 flex flex-col space-y-1.5"
    }, [_c('div', {
      staticClass: "text-2sm font-semibold text-gray-900"
    }, [_vm._v("\n                " + _vm._s(pro.value.value.intitule_parcours) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "text-2sm text-gray-600"
    }, [_vm._v("\n                " + _vm._s(pro.value.value.structure_accueil_parcours) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "text-2xs text-gray-600 whitespace-pre-line"
    }, [_vm._v("\n                " + _vm._s(pro.value.value.aborde_parcours) + "\n              ")])])]);
  }), 0)]) : _vm._e(), _vm._v(" "), _vm.formations.filter(function (f) {
    return f.isDisplayed;
  }).length > 0 ? _c('div', {
    staticClass: "flex flex-col space-y-1.5",
    attrs: {
      "id": "formations"
    }
  }, [_c('div', {
    class: 'text-base-2 ' + _vm.colorText + ' font-semibold uppercase'
  }, [_vm._v("\n          Formations\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "border-t border-gray-900 w-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-4 flex flex-col space-y-3.5"
  }, _vm._l(_vm.formations.filter(function (f) {
    return f.isDisplayed;
  }), function (formation, i) {
    return _c('div', {
      key: i,
      staticClass: "grid grid-cols-12 gap-x-2.5"
    }, [_c('div', {
      staticClass: "col-span-3 uppercase text-2sm font-semibold"
    }, [_vm._v("\n              " + _vm._s(_vm.formatDatesWithSeparator(formation)) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "col-span-9 flex flex-col space-y-1.5"
    }, [_c('div', {
      staticClass: "text-2sm font-semibold text-gray-900"
    }, [_vm._v("\n                " + _vm._s(formation.value.value.intitule_parcours) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "text-2sm text-gray-600"
    }, [_vm._v("\n                " + _vm._s(formation.value.value.localisation_parcours) + "\n              ")])])]);
  }), 0)]) : _vm._e(), _vm._v(" "), _vm.listCompetences.length > 0 ? _c('div', {
    staticClass: "flex flex-col space-y-1.5",
    attrs: {
      "id": "competences"
    }
  }, [_c('div', {
    class: 'text-base-2 ' + _vm.colorText + ' font-semibold uppercase'
  }, [_vm._v("\n          Compétences\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "border-t border-gray-900 w-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-2 gap-x-5 gap-y-1"
  }, _vm._l(_vm.listCompetences, function (comp) {
    return _c('div', {
      key: comp.value + 'basic2',
      staticClass: "text-gray-600 col-span-1 text-2sm"
    }, [_vm._v("\n            " + _vm._s(comp.value) + "\n          ")]);
  }), 0)]) : _vm._e()])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }